import i18n from 'app-i18n';
import { array, object, string } from 'yup';

export const addAttributesFormSchema = object({
  attributes: array().of(
    object({
      key: string().required(),
      value: string().required(),
    }),
  ),
  attributeKey: string().matches(/^\S*$/, () =>
    i18n.t('page.customers.form.attributes.attributeKeyError'),
  ),
});
